import React from "react";
import { ConsortiumMembersTable } from "./ConsortiumMembersTable";
import FMR1Table1Form from "./FMR1Table1Form";
import FMR1Table3Form from "./FMR1Table3Form";
import FMR1Table4Form from "./FMR1Table4Form";

const FMR1Part1Tab: React.FC = () => {
  const PART1_TWO_COL_LEFT_WIDTH_PX = 402 + 208;

  return (
    <>
      <FMR1Table1Form leftWidthPx={PART1_TWO_COL_LEFT_WIDTH_PX} />
      <ConsortiumMembersTable />
      <FMR1Table3Form leftWidthPx={PART1_TWO_COL_LEFT_WIDTH_PX} />
      <FMR1Table4Form leftWidthPx={PART1_TWO_COL_LEFT_WIDTH_PX} />
      <div className="h-20" />
    </>
  );
};

FMR1Part1Tab.displayName = "FMR1Part1Tab";

export default FMR1Part1Tab;
